import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operator',
  templateUrl: './operator.page.html',
  styleUrls: ['./operator.page.scss']
})
export class OperatorPage implements OnInit 
{
  constructor() {}

  ngOnInit(): void 
  {}
}
